export default "__VITE_ASSET__efec8a6a__"